export const workflowActions = {
  CREATE_WORKFLOW: 'CREATE_WORKFLOW',
  CREATE_RESPONSE: 'CREATE_RESPONSE',
  CREATE_STAGE: 'CREATE_STAGE',
  DUPLICATE_WORKFLOW_FOR_CONTEXT: 'DUPLICATE_WORKFLOW_FOR_CONTEXT',
  FETCH_WORKFLOW_BY_CONTEXT: 'FETCH_WORKFLOW_BY_CONTEXT',
  FETCH_WORKFLOW_BY_ID: 'FETCH_WORKFLOW_BY_ID',
  RESET_LOADING: 'RESET_LOADING',
  UPDATE_STAGE: 'UPDATE_STAGE',
  WORKFLOW_SUCCESS: 'WORKFLOW_SUCCESS',
  WORKFLOW_ERROR: 'WORKFLOW_ERROR',
}
